import React from 'react';
import { formatPostalCode } from '../../utils/stringUtil';
/**
 * Renders where a classified can be picked up.
 *
 * Handles both camelCase and snake_case API responses,
 * as the Kotlin backend returns slightly different
 * key spellings across its classified endpoints.
 * */
var PickupLocation = function (_a) {
    var classified = _a.classified;
    var camelPickupAt = classified.pickupAt, snakePickupAt = classified.pickup_at;
    var pickupAt = camelPickupAt || snakePickupAt;
    var camelSalePoint = classified.salePoint, snakeSalePoint = classified.sale_point;
    var salePoint = camelSalePoint || snakeSalePoint;
    if (pickupAt === 'school' && classified.school) {
        var school = classified.school;
        var name_1 = school.shortName || school.shortname || school.name;
        return React.createElement("section", { className: "pickup" },
            React.createElement("h3", null, name_1),
            school.department);
    }
    if (salePoint) {
        var zipCode = salePoint.zipCode || salePoint.zip_code;
        var salePointName = salePoint.salePoint || salePoint.sale_point || '';
        var postalCode = (zipCode === null || zipCode === void 0 ? void 0 : zipCode.id) ? formatPostalCode(zipCode.id) : '';
        return React.createElement("section", { className: "pickup" },
            React.createElement("h3", null, [postalCode, salePointName].filter(Boolean).join('\u00a0')), zipCode === null || zipCode === void 0 ? void 0 :
            zipCode.city);
    }
    return React.createElement("section", { className: "pickup" },
        React.createElement("h3", null, "Avtales med selger"));
};
export default PickupLocation;
